import React from 'react';
const MaintenancePage = () => (
  // <div style={{ textAlign: 'center', marginTop: '50px' }}>
  //   <h1>Maintenance Mode</h1>
  //   <p>The system is currently undergoing live maintenance. Please check back shortly.</p>
  // </div>
  <div className="container" style={{ textAlign: 'center', margin: '90 auto',background:"white",padding:"40px",borderRadius:"40px" }}>
    <img 
      src="https://cdn-icons-png.flaticon.com/512/565/565547.png" 
      alt="Maintenance Icon" 
      style={{ width: '120px', marginBottom: '20px',opacity:"0.9" }}
    />
    <h1 style={{marginBottom:"10px"}}>System Under Maintenance</h1>
    <p>We’re preparing for launch. Please check back soon!</p>
    <p className="time" style={{fontSize:"20PX",fontWeight:"bold",marginTop:"15px"}}>Go-Live Date: 22 Dec 2025 </p>
  </div>
);
export default MaintenancePage;